<form [formGroup]="printReportModalFormGroup">
  <h1 mat-dialog-title>Documentation Information</h1>
  <mat-dialog-content class="dialog-container">
    <div class="container">
      <div class="form-group row align-items-center">
        <div class="col-sm-8 align-self-center">
          <label for="textBox1">Facility:</label>
        </div>
        <div class="col-sm-4">
          <input
            type="text"
            name="textBox1"
            formControlName="textBox1"
            id="textBox1"
            class="form-control form-control-sm"
          />
        </div>
      </div>
      <div class="form-group row align-items-center">
        <div class="col-sm-8 align-self-center">
          <label for="textBox2">Plant:</label>
        </div>
        <div class="col-sm-4">
          <input
            type="text"
            name="textBox2"
            formControlName="textBox2"
            id="textBox2"
            class="form-control form-control-sm"
          />
        </div>
      </div>
      <div class="form-group row align-items-center">
        <div class="col-sm-8 align-self-center">
          <label for="textBox3">Equipment:</label>
        </div>
        <div class="col-sm-4">
          <input
            type="text"
            name="textBox3"
            formControlName="textBox3"
            id="textBox3"
            class="form-control form-control-sm"
          />
        </div>
      </div>
      <div class="form-group row align-items-center">
        <div class="col-sm-8 align-self-center">
          <label for="textBox4">Analyst:</label>
        </div>
        <div class="col-sm-4">
          <input
            type="text"
            name="textBox4"
            formControlName="textBox4"
            id="textBox4"
            class="form-control form-control-sm"
          />
        </div>
      </div>
      <div class="form-group row align-items-center">
        <div class="col-sm-8 align-self-center">
          <label for="textBox5">Design Pressure (psi):</label>
        </div>
        <div class="col-sm-4">
          <input
            type="number"
            name="textBox5"
            formControlName="textBox5"
            id="textBox5"
            class="form-control form-control-sm"
          />
        </div>
      </div>
      <div class="form-group row align-items-center">
        <div class="col-sm-8 align-self-center">
          <label for="textBox6">Design Temperature (deg-F):</label>
        </div>
        <div class="col-sm-4">
          <input
            type="number"
            name="textBox6"
            formControlName="textBox6"
            id="textBox6"
            class="form-control form-control-sm"
          />
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions">
    <button mat-button [mat-dialog-close]="false">Cancel</button>
    <button
      mat-button
      [mat-dialog-close]="true"
      cdkFocusInitial
      (click)="openReportPopout()"
    >
      Print
    </button>
  </mat-dialog-actions>
</form>
